module.exports = __webpack_public_path__ + "static/img/down.6e025f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/System/down.png
// module id = 3izU
// module chunks = 4